import { transparentize } from 'polished'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Box } from 'components/Layout'
import { COLOR_INTENT, SPACE, Z_INDEX } from 'Theme'

const TRANSITION_TIME = '250ms'

const fadeEffect = css`
  content: '';
  position: absolute;
  z-index: ${Z_INDEX.GALLERY_FADE_BOX};
  right: 0;
  pointer-events: none;
  width: 100%;
  height: ${SPACE.PX_40};
  transition: opacity ${TRANSITION_TIME} ease-in-out;
  opacity: 0;
`

export const ProductSwiperFadeBox = styled(Box)`
  &,
  * {
    user-select: none;
  }
  &::after {
    ${fadeEffect};
    ${({ isEnd, isLoop }) => (!isEnd || isLoop) && `opacity: 1;`};
    background-image: linear-gradient(
      180deg,
      ${transparentize(1, COLOR_INTENT.PRODUCT_GALLERY_FADE_BOX.GRADIENT)} 0%,
      ${COLOR_INTENT.PRODUCT_GALLERY_FADE_BOX.GRADIENT} 100%
    );
    bottom: 0;
  }

  &::before {
    ${fadeEffect};
    ${({ isBeginning, isLoop }) =>
      (!isBeginning && isBeginning !== undefined) || isLoop
        ? `opacity: 1;`
        : `opacity: 0;`};
    background-image: linear-gradient(
      0deg,
      ${transparentize(1, COLOR_INTENT.PRODUCT_GALLERY_FADE_BOX.GRADIENT)} 0%,
      ${COLOR_INTENT.PRODUCT_GALLERY_FADE_BOX.GRADIENT} 100%
    );
    top: 0;
  }
`

ProductSwiperFadeBox.propTypes = {
  isEnd: PropTypes.bool,
  isBeginning: PropTypes.bool,
  isLoop: PropTypes.bool,
}
